module.exports = __webpack_public_path__ + "static/no-bs-time-management-for-entrepreneurs-07487982cd508752934334d02bf244d4.jpg";